import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import _ from 'lodash';

import metadata from './MLPolicyBillingPaymentSchedulePopup.metadata.json5';
import styles from './MLPolicyBillingPaymentSchedulePopup.module.scss';

import React from 'react';

const MLPolicyBillingPaymentSchedulePopup = (props) => {
    const {
        invoices,
        convertLocalDateToDate,
        formatAmountString,
        onCancel
    } = props;

    const renderNumber = (item, index) => {
        return index + 1;
    };

    const renderDueDate = (item) => {
        return convertLocalDateToDate(item.dueDate_ML, 'MM/DD/YYYY');
    };

    const renderAmountDue = (item) => {
        return formatAmountString(item.amountDue);
    };

    const overrides = {
        paymentScheduleTable: {
            data: _.orderBy(invoices, ['dueDate', 'number'], ['asc'])
        }
    };

    const resolvers = {
        resolveCallbackMap : {
            renderNumber,
            renderDueDate,
            renderAmountDue,
            onClose: onCancel
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
};

MLPolicyBillingPaymentSchedulePopup.propTypes = {
    invoices: PropTypes.arrayOf(PropTypes.shape({})),
    convertLocalDateToDate: PropTypes.func,
    formatAmountString: PropTypes.func,
    onCancel: PropTypes.func
};

MLPolicyBillingPaymentSchedulePopup.defaultProps = {
    invoices: []
};

export default MLPolicyBillingPaymentSchedulePopup;
